<template>
  <div>
    <div class="form-gs">
      <el-form label-width="400px">
        <div v-for="(item,i) in listData" :key="i">
          <el-form-item :label="item.name+'：'" prop="title"
            v-if="item.key!='trans_today_show'&&item.key!='trans_small'&&item.key!='automatic_card_dispensing'&&item.key!='tanzania_airtel_all'&&item.key!='tanzania_tigo_all'&&item.key!='tanzania_vodacom_all'">
            <el-input style="width:500px" size="small" v-model="item.value" auto-complete="off"
              :placeholder="'Please enter '+item.name" clearable v-if="!item.key.includes('hide_mobile')">
            </el-input>
            <el-input type="textarea" style="width:500px" :rows="6" size="small" v-model="item.value"
              auto-complete="off" :placeholder="'Please enter '+item.name" clearable
              v-if="item.key.includes('hide_mobile')">
            </el-input>
          </el-form-item>
          <el-form-item :label="item.name+'：'" prop="title" v-if="item.key=='trans_today_show'">
            <el-radio v-model="item.value" label="1">Yes</el-radio>
            <el-radio v-model="item.value" label="2">No</el-radio>
          </el-form-item>
          <el-form-item :label="item.name+'：'" prop="title" v-if="item.key=='trans_small'">
            <el-radio v-model="item.value" label="1">Yes</el-radio>
            <el-radio v-model="item.value" label="0">No</el-radio>
          </el-form-item>
          <el-form-item :label="item.name+'：'" prop="title" v-if="item.key=='automatic_card_dispensing'">
            <el-radio v-model="item.value" label="1">Yes</el-radio>
            <el-radio v-model="item.value" label="0">No</el-radio>
          </el-form-item>
          <el-form-item :label="item.name+'：'" prop="title" v-if="item.key=='tanzania_airtel_all'">
            <el-radio v-model="item.value" label="1">Yes</el-radio>
            <el-radio v-model="item.value" label="0">No</el-radio>
          </el-form-item>
          <el-form-item :label="item.name+'：'" prop="title" v-if="item.key=='tanzania_tigo_all'">
            <el-radio v-model="item.value" label="1">Yes</el-radio>
            <el-radio v-model="item.value" label="0">No</el-radio>
          </el-form-item>
          <el-form-item :label="item.name+'：'" prop="title" v-if="item.key=='tanzania_vodacom_all'">
            <el-radio v-model="item.value" label="1">Yes</el-radio>
            <el-radio v-model="item.value" label="0">No</el-radio>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button size="medium" type="primary" :loading="loading" class="title" @click="submitForm">Save
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {
    settingList,
    settingSave,
  } from '../../api/apiFun'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        listData: [], //User数据
      }
    },
    created() {
      this.getdata()
    },
    methods: {
      // Edit、增加页面Save方法
      submitForm() {
        this.loading = true
        var editForm = [];
        this.listData.forEach(element => {
          editForm.push({
            "key": element.key,
            "value": element.value,
          }, )
        });
        settingSave(JSON.stringify(editForm), this.params).then(res => {
          this.loading = false
          if (res.code == 200) {
            this.getdata()
            this.$message({
              type: 'success',
              message: 'Saved successfully'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Saving failed, please try again later!')
        })
      },
      // 获取Config列表
      getdata(parameter) {
        this.loading = true
        settingList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get config list, please try again later!')
        })
      },
    }
  }

</script>
<style scoped>
  .form-gs {
    width: 100%;
    display: flex;
    justify-items: center;
    margin-top: 30px
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/system/setting_list.vue